import { render, staticRenderFns } from "./SecretaryList.vue?vue&type=template&id=f96e558c&"
import script from "./SecretaryList.vue?vue&type=script&lang=js&"
export * from "./SecretaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports